class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

static renderFilters(html, event) {
  const parsed = new DOMParser().parseFromString(html, 'text/html');

  // 🔹 Remember active tab before replacement
  const formMobile = document.getElementById('FacetFiltersFormMobile');
  let activeTabId = null;
  if (formMobile) {
    const activeTab = formMobile.querySelector('.vtabs__tab.is-active');
    if (activeTab) activeTabId = activeTab.dataset.tab;
  }

  // ✅ Swap forms
  const blocks = ['#FacetFiltersForm', '#FacetFiltersFormMobile', '#FacetFiltersPillsForm'];
  blocks.forEach((sel) => {
    const incoming = parsed.querySelector(sel);
    const current  = document.querySelector(sel);
    if (incoming && current) current.innerHTML = incoming.innerHTML;
  });

  // Active pills / headers etc.
  FacetFiltersForm.renderActiveFacets(parsed);
  FacetFiltersForm.renderAdditionalElements(parsed);

  updateVTabCounts(parsed);

  // re-arm drawer
  const drawer = document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer');
  drawer?.bindEvents?.();

  document.querySelectorAll('#FacetFiltersFormMobile .vtabs__tab').forEach((b) => (b.type = 'button'));

  // 🔹 Restore previously active tab (after swap)
  if (activeTabId) {
    const root = document.getElementById('FacetFiltersFormMobile');
    const tab  = root.querySelector(`.vtabs__tab[data-tab="${activeTabId}"]`);
    const panel = root.querySelector(`#${activeTabId}`);
    if (tab && panel) {
      root.querySelectorAll('.vtabs__tab').forEach(t => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      root.querySelectorAll('.vtabs__panel').forEach(p => p.classList.add('is-hidden'));

      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      panel.classList.remove('is-hidden');
    }
  }
}

static renderActiveFacets(html) {
  const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

  activeFacetElementSelectors.forEach((selector) => {
    const activeFacetsElement = html.querySelector(selector);
    if (!activeFacetsElement) return;
    document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
  });

  // ✅ ADD THIS for your custom location
  const customActiveFacetsElement = html.querySelector('.active-facets-desktop');
  const customContainer = document.querySelector('.custom-active-filters');
  if (customActiveFacetsElement && customContainer) {
    customContainer.innerHTML = customActiveFacetsElement.innerHTML;
  }

  FacetFiltersForm.toggleActiveFacets(false);
}

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const el = event.target;

const isFacetInput =
  (el.classList && el.classList.contains('mobile-facets__checkbox')) ||
  (el.matches && el.matches('price-range input')) ||         // price inputs
  (el.type === 'checkbox' && el.name && el.name.startsWith('filter.')); // any filter checkbox fallback

if (isFacetInput) {
  const form = el.closest('form');
  const searchParams = this.createSearchParams(form);
  this.onSubmitForm(searchParams, event);
} else {
  const forms = [];
  const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

  document.querySelectorAll('facet-filters-form form').forEach((form) => {
    if (!isMobile) {
      if (
        form.id === 'FacetSortForm' ||
        form.id === 'FacetFiltersForm' ||
        form.id === 'FacetSortDrawerForm' ||
        form.id === 'FacetSortFormsticky'
      ) {
        forms.push(this.createSearchParams(form));
      }
    } else if (form.id === 'FacetFiltersFormMobile') {
      forms.push(this.createSearchParams(form));
    }
  });

  this.onSubmitForm(forms.join('&'), event);
}

  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}
function updateVTabCounts(parsedHTML) {
  const form = document.getElementById('FacetFiltersFormMobile');
  if (!form) return;

  // If mobile viewport, remove any existing badges and exit
  if (window.matchMedia('(max-width: 749px)').matches) {
    form.querySelectorAll('.vtabs__tab .vtabs__tab-count').forEach((el) => el.remove());
    return; // ✅ nothing to add on mobile
  }

  // (Desktop logic — keep if you ever show this UI on desktop)
  const tabs = form.querySelectorAll('.vtabs__tab');

  tabs.forEach((tab) => {
    let countSpan = tab.querySelector('.vtabs__tab-count');
    if (!countSpan) {
      countSpan = document.createElement('span');
      countSpan.className = 'vtabs__tab-count';
      tab.appendChild(countSpan);
    }

    const panel = form.querySelector(`#${tab.dataset.tab}`);
    if (!panel) {
      countSpan.textContent = '';
      return;
    }

    let activeCount = panel.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').length;

    const pr = panel.querySelector('price-range');
    if (pr) {
      const [minI, maxI] = pr.querySelectorAll('input');
      const minV = (minI && minI.value.trim()) || '';
      const maxV = (maxI && maxI.value.trim()) || '';
      if (minV !== '' || maxV !== '') activeCount = Math.max(activeCount, 1);
    }

    countSpan.textContent = activeCount > 0 ? activeCount : '';
  });
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

document.addEventListener('DOMContentLoaded', () => {
  const stickySortForm = document.getElementById('FacetSortFormsticky');
  if (stickySortForm) {
    stickySortForm.addEventListener('change', function (event) {
      const facetForm = document.querySelector('facet-filters-form');
      const searchParams = facetForm.createSearchParams(this);
      facetForm.onSubmitForm(searchParams, event);
    });
  }
});

document.addEventListener('click', function (e) {
  const tab = e.target.closest('#FacetFiltersFormMobile .vtabs__tab');
  if (!tab) return;
  e.preventDefault(); e.stopPropagation();

  const root = tab.closest('#FacetFiltersFormMobile');
  const panels = root.querySelectorAll('.vtabs__panel');
  const tabs   = root.querySelectorAll('.vtabs__tab');
  const targetId = tab.dataset.tab;

  tabs.forEach(t => {
    const active = t === tab;
    t.classList.toggle('is-active', active);
    t.setAttribute('aria-selected', active ? 'true' : 'false');
  });
  panels.forEach(p => p.classList.toggle('is-hidden', p.id !== targetId));
}, true);

document.addEventListener('keydown', function (e) {
  const tab = e.target.closest('.vtabs__tab');
  if (!tab) return;
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    tab.click();
  }
}, true);
// capture phase so menu-drawer doesn't swallow the click

// Keyboard support for accessibility
document.addEventListener('keydown', function (e) {
  const tab = e.target.closest('.vtabs__tab');
  if (!tab) return;
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    tab.click();
  }
}, true);


document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'sort_by') {
      const formEl = e.target.closest('form');
      const facetEl = document.querySelector('facet-filters-form');
      if (formEl && facetEl && facetEl.createSearchParams) {
        const params = facetEl.createSearchParams(formEl);
        facetEl.onSubmitForm(params, e);
      }
    }
  }, true);

